/**
 * Client parity for `config/exploreUnknownLeveling.json` milestone preview.
 * Used when `exploreUnknownXpGrant.nextLevelMilestoneBonus` is absent (older server payloads).
 */

const MILESTONE_LEVELS = Object.freeze([
  5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100,
]);

/** @type {Readonly<Record<string, { icon: string, i18nKey: string, bonusId: string }>>} */
const MILESTONE_BONUSES = Object.freeze({
  '5': { bonusId: 'preparationBonus', icon: '/images/plan_ahead.jpg', i18nKey: 'levelBonus5' },
  '10': { bonusId: 'memory', icon: '/images/happy.jpg', i18nKey: 'levelBonus10' },
  '15': { bonusId: 'diplomaticAccords', icon: '/images/emergency_protocol.jpg', i18nKey: 'levelBonus15' },
  '20': { bonusId: 'factionOrders', icon: '/images/any_faction.jpg', i18nKey: 'levelBonus20' },
  '25': { bonusId: 'hearts', icon: '/images/heart.jpg', i18nKey: 'levelBonus25' },
  '30': { bonusId: 'emergencyProtocol', icon: '/images/ep_board.jpg', i18nKey: 'levelBonus30' },
  '35': { bonusId: 'darkKnowledge', icon: '/images/dark_knowledge.jpg', i18nKey: 'levelBonus35' },
  '40': { bonusId: 'rewriteExperience', icon: '/images/retry.jpg', i18nKey: 'levelBonus40' },
  '45': { bonusId: 'skipWorld', icon: '/images/shadowverse_desert.jpg', i18nKey: 'levelBonus45' },
  '50': { bonusId: 'darknessReduction', icon: '/images/sad.jpg', i18nKey: 'levelBonus50' },
  '55': { bonusId: 'healthPerWin', icon: '/images/weak_heart.jpg', i18nKey: 'levelBonus55' },
  '60': { bonusId: 'memoryBonusDarkness', icon: '/images/embarrassing.jpg', i18nKey: 'levelBonus60' },
  '65': { bonusId: 'heartHealthBonus', icon: '/images/strong_heart.jpg', i18nKey: 'levelBonus65' },
  '70': { bonusId: 'epFewerFragments', icon: '/images/ep_board.jpg', i18nKey: 'levelBonus70' },
  '75': { bonusId: 'rewriteFewerFragments', icon: '/images/retry.jpg', i18nKey: 'levelBonus75' },
  '80': { bonusId: 'autoCollectMemory', icon: '/images/happy.jpg', i18nKey: 'levelBonus80' },
  '85': { bonusId: 'autoCollectDarkKnowledge', icon: '/images/dark_knowledge.jpg', i18nKey: 'levelBonus85' },
  '90': { bonusId: 'autoCollectRewrite', icon: '/images/retry.jpg', i18nKey: 'levelBonus90' },
  '95': { bonusId: 'autoCollectEp', icon: '/images/ep_board.jpg', i18nKey: 'levelBonus95' },
  '100': { bonusId: 'singleFragment', icon: '/images/168.jpg', i18nKey: 'levelBonus100' },
});

/**
 * @param {number} currentLevel
 * @returns {{ level: number, bonusId: string, icon: string, i18nKey: string }|null}
 */
export function getImmediateNextMilestoneBonusFromLevel(currentLevel) {
  const lv = Number(currentLevel);
  if (!Number.isInteger(lv) || lv < 1) {
    return null;
  }
  const next = lv + 1;
  if (!MILESTONE_LEVELS.includes(next)) {
    return null;
  }
  const meta = MILESTONE_BONUSES[String(next)];
  if (!meta) {
    return null;
  }
  return { level: next, ...meta };
}

export { MILESTONE_LEVELS, MILESTONE_BONUSES };
